// extracted by mini-css-extract-plugin
export default {"line":"styles_line__+L7n3","top22":"styles_top22__WkbKH","accent":"styles_accent__0yDdh","bold":"styles_bold__8wKt+","small":"styles_small__+8cka"};